export const getBrowserLocalStorage = () => {
    if (typeof window === 'undefined') return null;

    try {
        return window.localStorage || null;
    } catch (_) {
        return null;
    }
};

export const getLocalStorageItem = (key) => {
    const storage = getBrowserLocalStorage();
    if (!storage) return null;

    try {
        return storage.getItem(key);
    } catch (_) {
        return null;
    }
};

export const setLocalStorageItem = (key, value) => {
    const storage = getBrowserLocalStorage();
    if (!storage) return false;

    try {
        storage.setItem(key, value);
        return true;
    } catch (_) {
        return false;
    }
};

export const removeLocalStorageItem = (key) => {
    const storage = getBrowserLocalStorage();
    if (!storage) return false;

    try {
        storage.removeItem(key);
        return true;
    } catch (_) {
        return false;
    }
};
